import React from 'react'
import Content from '../Content/Content'
import { style } from './Index.style'
import SectionTitle from '../SectionTitle/SectioinTitle'
import NewsList from './NewsList'
import Footer from './Footer'

const Event = () => {
  return (
    <section id="event_section" css={style.section}>
      <Content>
        <SectionTitle sectionSubTitle="EVENT" sectionTitle="イベント・研修会" />
        <NewsList subcategory="event" />
        <Footer subcategory="event" />
      </Content>
    </section>
  )
}

export default Event
